import {
	DefaultButtonCompat as DefaultButton,
	DialogCompat as Dialog,
	DialogType,
	IDialogProps,
	PrimaryButtonCompat as PrimaryButton,
	StackCompat as Stack,
} from 'components/FluentUICompat';
import {useTranslation} from 'react-i18next';
import React from 'react';

export type ConfirmDeleteDialogProps = Omit<IDialogProps, 'modalProps'> & {
	onConfirm: () => void;
	itemCount?: number;
	customSubtextTranslationKey?: string;
};

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
	dialogContentProps,
	itemCount,
	customSubtextTranslationKey,
	...props
}) => {
	const {t} = useTranslation('components/dialogs', {
		keyPrefix: 'ConfirmDeleteDialog',
	});

	return (
		<Dialog
			dialogContentProps={{
				type: DialogType.normal,
				title: t('Title'),
				subText: customSubtextTranslationKey
					? t(customSubtextTranslationKey)
					: t('Subtext', {count: itemCount}),
				...dialogContentProps,
			}}
			{...props}
			modalProps={{
				isBlocking: true,
				styles: {main: {maxWidth: 450}},
			}}
		>
			<Stack horizontal horizontalAlign='end' tokens={{childrenGap: 5}}>
				<Stack.Item>
					<DefaultButton
						onClick={props.onDismiss as any}
						ariaLabel={'CancelDialogButton'}
					>
						{t('Cancel')}
					</DefaultButton>
				</Stack.Item>
				<Stack.Item>
					<PrimaryButton
						onClick={props.onConfirm}
						ariaLabel={'DeleteDialogButton'}
					>
						{t('Delete')}
					</PrimaryButton>
				</Stack.Item>
			</Stack>
		</Dialog>
	);
};
